import { Button, ButtonProps } from "@progress/kendo-react-buttons";
import { type LucideIcon } from "lucide-react";
import React from "react";
import ToolTip from "@/components/Kendo/ToolTip";
import { ISVG } from "@/icons/interface";
import "./iconButton.scss";
const IconButton: React.FC<
  React.PropsWithChildren &
    ButtonProps & {
      Icon:
        | React.FC<ISVG>
        | React.FC<React.SVGProps<SVGSVGElement>>
        | LucideIcon;
      testId?: string;
      parentTitle?: boolean;
      size?: ButtonProps["size"];
    }
> = props => {
  const { Icon, testId, title, parentTitle = true, ...rest } = props;
  const buttonProps = {
    ...rest,
    fillMode: rest.fillMode || "outline",
    size: rest.size || "medium",
  };

  const button = (
    <Button {...buttonProps} style={buttonProps.style} data-test-id={testId}>
      <span className="tlx-icon-button-content">
        <span className="k-icon tlx-svg-icon  k-button-icon">
          <Icon height={20} width={20} />
        </span>
        {props.children ? <span> {props.children}</span> : null}
      </span>
    </Button>
  );

  if (title) {
    return (
      <ToolTip title={title} parentTitle={parentTitle} position="bottom">
        {button}
      </ToolTip>
    );
  }

  return button;
};

export default IconButton;
